module.exports = __webpack_public_path__ + "img/master-m.fdca82de.png";